// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"609":"9a9fa7ea","622":"34161dd2","779":"34161dd2","997":"8edb27cd"}[chunkId] + ".chunk.css";
};